import * as types from "./actionTypes"

const initialState = {
    show: false,
    message: "",
    alertType: "",
}

export default function notificationReducer(state = initialState, action) {
    switch (action.type) {
        case types.SHOW_NOTIFICATION:
            return {
                ...state,
                show: action.payload.show,
                message: action.payload.message,
                alertType: action.payload.alertType,
            }

        default:
            return state
    }
}
